import React, { useContext } from 'react'
import "../CSS/Header2.css"
import { Context } from './Context'
import Logo from "../Images/logo gif (2).gif"
import { useLocation, useNavigate } from 'react-router-dom'

const Header2 = () => {
    const {active,setActive}=useContext(Context)
    const location = useLocation()
    const navigate = useNavigate()

    const handleAbout = (about) => {
        
        if (about) {
          const element = document.getElementById('about');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }
      };

      const handleExperience = (experience) => {
        if (experience) {
          const element = document.getElementById('experience');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }
      };

      const handleProjects = (projects) => {
        if (projects) {
          const element = document.getElementById('projects');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }
      };


  return (
    <div className='container-fluid p-5 Header2Wrap'>
        <div className='row Header2'>
            <div className='col-md-4 Header2Left'>
                <img src={Logo} alt="logo"/>
            </div>
            <div className='col-md-8 Header2Right'>
                <p onClick={()=>{setActive("Home");navigate("/");window.scrollTo(0,0)}} className={location.pathname==="/"?"NavLinkActive":'NavLink'}>Home</p>
                {location.pathname==="/"&&<p onClick={()=>handleAbout("about")} className={active==="About"?"NavLinkActive":'NavLink'}>About</p>}
                {location.pathname==="/"&&<p onClick={()=>handleExperience("experience")} className={active==="Experience"?"NavLinkActive":'NavLink'}>Experience</p>}
                {location.pathname==="/"&&<p onClick={()=>handleProjects("projects")} className={active==="Projects"?"NavLinkActive":'NavLink'}>Projects</p>}
                <p onClick={()=>{setActive("Contact");navigate("/contactus")}} className={location.pathname==="/contactus"?"NavLinkActive":'NavLink'}>Contact</p>
            </div>
        </div>
    </div>
  )
}

export default Header2
